import type { VoidFunctionComponent } from 'react';

import styles from './ProjectPreview.module.less';

/**
 * Badge displayed at the top of the scan summary header
 */
const ScanSummaryBadge: VoidFunctionComponent = () => (
  <div className={`hidden-xs hidden-sm ${styles.scanSummaryBadge}`}>
    <i className={`fossa-icon-checklist ${styles.scanSummaryBadgeIcon}`} />
    <b className="inline-header">Scan summary</b>
  </div>
);

export default ScanSummaryBadge;
